/**
 * productNameMatch — Namensähnlichkeit zwischen Shopify- und FieldConnect-Produkten.
 *
 * Hintergrund: Shopify-Titel sind Marketing-Titel („Müllsäcke 120 l schwarz extra
 * stark – 100 my, 100 Stück"), die FC-Altnamen sind knapp („Müllsäcke 120l schwarz
 * extra stark"). Ohne SKU-Treffer legt der Katalog-Import sonst ein NEUES Produkt an
 * — die Kundenpreise, Belege und Lagerbewegungen bleiben am alten Datensatz hängen.
 * Diese Erkennung markiert solche Fälle VOR dem Import.
 */

const UMLAUTE = { ä: 'a', ö: 'o', ü: 'u', ß: 's', à: 'a', á: 'a', é: 'e', è: 'e' };

// Füllwörter, die nur in Shopify-Titeln vorkommen und nichts unterscheiden
const FUELLWOERTER = new Set([
  'stuck', 'stk', 'lagig', 'ca', 'ohne', 'mit', 'fsc', 'my', 'cm', 'mm', 'x',
  'und', 'pro', 'a', 'je', 'der', 'die', 'das', 'fur',
]);

const SYNONYME = { lg: 'lagig', stueck: 'stuck', stk: 'stuck' };

/** Produktnamen in eine vergleichbare Token-Menge zerlegen. */
export function nameTokens(name) {
  const roh = (name || '')
    .toLowerCase()
    .replace(/[äöüßàáéè]/g, (c) => UMLAUTE[c] || c)
    .replace(/[^a-z0-9]+/g, ' ')
    // „120l" → „120 l", „40cm" → „40 cm", damit Zahl und Einheit einzeln zählen
    .replace(/(\d)([a-z])/g, '$1 $2')
    .replace(/([a-z])(\d)/g, '$1 $2');

  return new Set(
    roh
      .split(' ')
      .filter(Boolean)
      .map((w) => SYNONYME[w] || w)
      .filter((w) => !FUELLWOERTER.has(w)),
  );
}

/**
 * Sucht den wahrscheinlichsten Alt-Datensatz zu einem Shopify-Titel.
 *
 * Treffer nur, wenn ALLE bedeutungstragenden Tokens des Kandidaten im Shopify-Titel
 * vorkommen (Abdeckung 100 %) und dieser Kandidat eindeutig ist. Damit werden
 * Größen-/Farbvarianten („40 cm" vs. „33 cm", „weiß" vs. „rot") nie verwechselt.
 *
 * @param {string} shopifyTitle
 * @param {Array<{id:string,name:string,sku?:string,is_active?:boolean}>} kandidaten
 * @returns {object|null} das eindeutig passende Produkt oder null
 */
export function findLikelyDuplicate(shopifyTitle, kandidaten) {
  const ziel = nameTokens(shopifyTitle);
  if (ziel.size === 0) return null;

  const treffer = (kandidaten || []).filter((p) => {
    const t = nameTokens(p.name);
    if (t.size === 0) return false;
    for (const w of t) if (!ziel.has(w)) return false;
    return true;
  });

  return treffer.length === 1 ? treffer[0] : null;
}
